import React, {useEffect, useState} from 'react'
import Loader from "../../../../../Loader/Loader";
import DashboardMenu from "../../../../layout/dashboardMenu";
import Header from "../../../../layout/header";
import ReactPaginate from "react-paginate";
import NotFoundData from "../../../../../Images/no-data-found.webp";
import Moment from "moment/moment";
import BottomMenu from "../../../../layout/bottomMenu";

const CaseListingV2 = ({
                         caseListRequest,
                         caseListResponse = [],
                         history,
                         match
                    }) => {

    const status = {
        'LOGGED_IN' : 'Logged In',
        'REQUEST_FOR_CASE_APPROVAL' : 'Request For Case Approval',
        'REQUEST_FOR_CASE_MODIFICATION' : 'Request For Case Modification',
        'APPROVED' : 'Approved',
        'REJECTED' : 'Rejected',
        'CANCELLED' : 'Cancelled',
        'PAYMENT_DETAILS_ADDED' : 'Payment Added',
        'REQUEST_FOR_PAYMENT_RELEASE' : 'Payment Release Request',
        'REQUEST_FOR_PAYMENT_MODIFICATION' : 'Payment Modification',
        'REQUEST_FOR_PAYMENT_RELEASE_APPROVED' : 'Payment Release Approved',
        'PARTIAL_PAYMENT_RELEASED' : 'Partial Payment Released',
        'COMPLETE_PAYMENT_RELEASED' : 'Payment Released',
    };

    const color = {
        'LOGGED_IN' : '#bea925',
        'REQUEST_FOR_CASE_APPROVAL' : '#888888',
        'REQUEST_FOR_CASE_MODIFICATION' : '#401714',
        'APPROVED' : '#10b817',
        'REJECTED' : '#88130a',
        'CANCELLED' : '#88130a',
        'PAYMENT_DETAILS_ADDED' : '#1c4c1b',
        'REQUEST_FOR_PAYMENT_RELEASE' : '#36c3b8',
        'REQUEST_FOR_PAYMENT_MODIFICATION' : 'rgba(99,7,96,0.73)',
        'REQUEST_FOR_PAYMENT_RELEASE_APPROVED' : '#0dc10f',
        'PARTIAL_PAYMENT_RELEASED' : '#cc6613',
        'COMPLETE_PAYMENT_RELEASED' : '#123e02',
    }

    const [isLoading, setIsLoading] = useState(false)
    const [searchValue, setSearchValue] = useState('')
    const [filterInputList, setFilterInputList] = useState([{}])
    const [open, setOpen] = useState(false);
    const [isFilterRemove, setIsRemoveFilter] = useState(false)
    const [pageNo, setPage] = useState(1)
    const [userId, setUserId] = useState('');

    const onPageChange = async (val) => {
        setIsLoading(true)
        setPage(val?.selected + 1)
        await caseListRequest(match?.params?.dealer_id, val?.selected + 1)
        setIsLoading(false)
    };

    useEffect(() => {
        (async () => {
            setUserId(window.localStorage.user_id);
            let filter = window.localStorage.case_filter ? JSON.parse(window.localStorage.case_filter) : [{}];
            setIsLoading(true)
            await caseListRequest(match?.params?.dealer_id, pageNo, filter)
            setIsLoading(false)
        })()
    }, [])

    const handlePreviousUrl = () => {
        // localStorage.setItem('previous_url', previousPageUrl)
    }

    const handleFilter = async (key, value, stringValue = '') => {

        const list = [...filterInputList]
        list[0][key] = value
        setFilterInputList(list)
    }

    const handleSearch = async () => {
        if (searchValue === '') {
            return false
        }
        setIsLoading(true)
        await caseListRequest(match?.params?.dealer_id, pageNo, searchValue)
        setIsLoading(false)
    }

    const removeSearchFilter = async () => {
        delete window.localStorage.search_ucd_dealer
        setIsLoading(true)
        await caseListRequest(match?.params?.dealer_id, pageNo)
        setIsLoading(false)
    }

    const handleSubmitFilter = async () => {
        window.localStorage.case_filter = JSON.stringify(filterInputList);
        setOpen(false)
        setIsLoading(true)
        await caseListRequest(match?.params?.dealer_id, pageNo, filterInputList);
        setIsLoading(false)
    }

    const handleRemoveFilter = async (key) => {
        if (key !== '') {
            delete filterInputList[0][key]
            window.localStorage.case_filter = JSON.stringify(filterInputList);
            setFilterInputList(filterInputList)
            setIsLoading(true)
            await caseListRequest(match?.params?.dealer_id, pageNo, filterInputList);
            setIsLoading(false)
        }
    }
    //
    useEffect(() => {
        (async () => {
            if (isFilterRemove) {
                setFilterInputList([{}])
                delete window.localStorage.case_filter;
                setIsLoading(true)
                await caseListRequest(match?.params?.dealer_id, 1);
                setPage(1);
                setIsLoading(false)
                setIsRemoveFilter(false)
            }
        })()
    }, [isFilterRemove])

    const userProfile = localStorage.getItem('user_profile');

    if (userProfile) {
        const parsedUserProfile = JSON.parse(userProfile);
        // const userId = parseInt(parsedUserProfile.id);
    }

    console.log("caseListResponse?.data?.resultSets?.length", caseListResponse)

    return (
        <>
            <Loader isLoading={isLoading}/>
            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={'Case List'}
                            history={history}
                        />
                        <div className="container-fluid common-bg">
                            {/*Heading*/}
                            <div className="container-fluid bootstrap snippets bg-white">
                                <div className="d-sm-flex align-items-center justify-content-between ">
                                    <div className="row col-md-12">
                                        <div className="col-md-6 col-sm-6 d-flex mt-20px ">
                                            {/*<form className="form-inline mr-auto w-90 navbar-search">*/}
                                            {/*    <div className="d-flex w-100">*/}
                                            {/*        <input type="text"*/}
                                            {/*               className="form-control bg-light border-0 small list-filter"*/}
                                            {/*               placeholder="Search Dealer..." aria-label="Search"*/}
                                            {/*               aria-describedby="basic-addon2"*/}
                                            {/*               onChange={(e) => {*/}
                                            {/*                   setSearchValue(e.target.value)*/}
                                            {/*               }}*/}
                                            {/*        />*/}
                                            {/*        <div className="remove-search-filter">*/}
                                            {/*            <i className="fa fa-times" aria-hidden="true"*/}
                                            {/*               onClick={removeSearchFilter}></i>*/}
                                            {/*        </div>*/}
                                            {/*        <div className="btn-search">*/}
                                            {/*            <button className="btn btn-primary lh-32 border-left-tr-tb"*/}
                                            {/*                    type="button"*/}
                                            {/*                    onClick={(e) => handleSearch()}*/}
                                            {/*            >*/}
                                            {/*                <i className="fas fa-search fa-sm"></i>*/}
                                            {/*            </button>*/}
                                            {/*        </div>*/}
                                            {/*    </div>*/}
                                            {/*</form>*/}
                                        </div>
                                        <div className="col-md-6 cs-pos">
                                            <button onClick={() => setOpen(!open)}
                                                    className="btn btn-sm btn-primary mr-1 btn-filter"
                                                    type="button"><i
                                                className="fa fa-filter lh-35 pd-3"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {console.log("TESRERL: ", filterInputList[0] )}

                                {/* Filter View */}
                                {filterInputList[0] !== undefined && Object.keys(filterInputList[0]).length > 0 &&
                                    <div className="d-sm-flex align-items-center justify-content-between mb-4 mt-5">
                                        <div className="row pd-filter-div">
                                            <div className="col-md-12 col-sm-12 d-flex">
                                                <div className="applied-filter">
                                                    {Object.keys(filterInputList[0]).map((val, i) => {
                                                        return (
                                                            <>
                                                            <span className="fd-1">
                                                                <span style={{textTransform: "capitalize"}}>
                                                                    {val.replaceAll("_", " ")}
                                                                </span>
                                                                {" - " + filterInputList[0][val]}
                                                                <i className="bi bi-x-circle" onClick={(e) => {
                                                                    handleRemoveFilter(val)
                                                                }}></i></span>
                                                            </>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                {/* Filter View End*/}

                                <div className="row mt-5">
                                    {/*CARD START*/}
                                    {caseListResponse && caseListResponse?.data !== undefined && caseListResponse?.data !== []  && caseListResponse?.data?.resultSets?.length > 0
                                        && caseListResponse?.data?.resultSets.map((val, i) => {
                                        return (
                                            <>
                                                <div className="col-md-4 col-sm-6">
                                                    <div className="card-big-shadow">
                                                        <div className="card card-just-text" data-background=""
                                                             data-color=""
                                                             data-radius="none" style={{zIndex:0}}>
                                                            <div className="content">
                                                                <h6 className="category mrg-b-12">
                                                                    <div className="header-ui-item-opp"
                                                                         style={{backgroundColor: `${color[val.status]}`}}>
                                                                        {status[val.status]}
                                                                    </div>
                                                                    {(val.status === 'APPROVED' || val?.status === 'REQUEST_FOR_PAYMENT_MODIFICATION' || val?.status === 'PAYMENT_DETAILS_ADDED' ||
                                                                        val.status === 'REQUEST_FOR_PAYMENT_RELEASE' || val.status === 'REQUEST_FOR_PAYMENT_RELEASE_APPROVED' ||
                                                                        val.status !== 'COMPLETE_PAYMENT_RELEASED' || val?.status !== 'REQUEST_FOR_CASE_APPROVAL') &&
                                                                        <div className="dropdown"
                                                                             style={{"float": "left"}}>
                                                                            <i className="bi bi-three-dots-vertical"
                                                                               data-toggle="dropdown"
                                                                               style={{color: "black"}}></i>
                                                                            <ul className="dropdown-menu">
                                                                                <li><a
                                                                                    href={`payment-raise-release-request/${val?.id}`}
                                                                                    className="btn btn-sm"
                                                                                    type="button"
                                                                                >Payment Pending Request</a>
                                                                                </li>
                                                                                <li>
                                                                                    <a
                                                                                        href={`rc-status-remark/${val?.id}`}>
                                                                                        <i className="btn btn-sm"
                                                                                           aria-hidden="true"></i>&nbsp;&nbsp;
                                                                                        RC Remark
                                                                                    </a>
                                                                                </li>
                                                                                {val?.enable_payout_view == true && (
                                                                                <li><a
                                                                                    href={`payout-details/${val?.id}`}
                                                                                    className="btn btn-sm"
                                                                                    type="button"
                                                                                >Payout Details</a>
                                                                                </li>
                                                                                )}
                                                                            </ul>
                                                                        </div>
                                                                    }

                                                                    <div className="row list-view">
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="fa fa-id-card"
                                                                                   style={{color: 'black'}}></i>&nbsp;&nbsp;Loan
                                                                                Id
                                                                            </div>
                                                                            <div className="col-md-6 col-sm-6 l2">
                                                                                <span className="trigger"
                                                                                      data-tooltip-id="1"
                                                                                >{val?.id}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="fa fa-tv"></i>&nbsp;&nbsp;Loan
                                                                                Type
                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6 l2">
                                                                                <span className="trigger"
                                                                                      data-tooltip-id="1"
                                                                                      title={val?.loan_type}>{val?.loan_type}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="fas fa-car-side"
                                                                                   style={{color: '#6b4ebe'}}></i>&nbsp;&nbsp;Vehicle
                                                                                No
                                                                            </div>
                                                                            <div className="col-md-6 col-sm-6 l2">
                                                                                <span className="trigger"
                                                                                      data-tooltip-id="1"
                                                                                      title={val?.vehicle_registration_number}>{val?.vehicle_registration_number}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="fa fa-university"
                                                                                   style={{color: '#07076d'}}></i>&nbsp;&nbsp;Bank
                                                                                Name
                                                                            </div>
                                                                            <div className="col-md-6 col-sm-6 l2">
                                                                                <span className="trigger"
                                                                                      data-tooltip-id="1"
                                                                                      title={val?.bank_name}>{val?.bank_name}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="fa fa-user"
                                                                                   style={{color: 'crimson'}}></i>&nbsp;&nbsp;Customer
                                                                                Name
                                                                            </div>
                                                                            <div className="col-md-6 col-sm-6 l2">
                                                                                <span className="trigger"
                                                                                      data-tooltip-id="1"
                                                                                      title={val?.customer_name}>{val?.customer_name}</span>
                                                                            </div>
                                                                        </div>
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="fas fa-rupee-sign"
                                                                                   style={{color: 'green'}}
                                                                                   aria-hidden="true"></i>

                                                                                &nbsp;&nbsp;Loan Amount
                                                                            </div>
                                                                            <div className="col-md-6 col-sm-6 l2">
                                                                                <span className="trigger"
                                                                                      data-tooltip-id="1"
                                                                                      title={val?.loan_required_amount}>{val?.loan_required_amount}</span>
                                                                            </div>
                                                                        </div>
                                                                        {val?.dealer_gst_no !== null &&
                                                                            <div className="mb-flex">
                                                                                <div
                                                                                    className="col-md-6 col-sm-6 no-wrap">
                                                                                    <i className="fa fa-user"
                                                                                       style={{color: 'brown'}}></i>

                                                                                    &nbsp;&nbsp;Created By
                                                                                </div>
                                                                                <div className="col-md-6 col-sm-6 l2">
                                                                                    <span className="trigger"
                                                                                          data-tooltip-id="1"
                                                                                          title={val?.created_user_name}>{val?.created_user_name}</span>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                        <div className="mb-flex">
                                                                            <div
                                                                                className="col-md-6 col-sm-6 no-wrap">
                                                                                <i className="fas fa-calendar-alt"></i>&nbsp;&nbsp;Created
                                                                                Date
                                                                            </div>
                                                                            <div
                                                                                className="col-md-6 col-sm-6">{Moment(val?.created_at).format('DD-MM-YYYY')}</div>
                                                                        </div>
                                                                        {val?.remark &&
                                                                            <div className="mb-flex">
                                                                                <div
                                                                                    className="col-md-6 col-sm-6 no-wrap">
                                                                                    <i className="bi bi-person-check-fill"></i>&nbsp;&nbsp;Remark
                                                                                </div>
                                                                                <div
                                                                                    className="col-md-6 col-sm-6">
                                                                                     <span className="trigger"
                                                                                           data-tooltip-id="1"
                                                                                           title={val?.remark}>{val?.remark}</span>
                                                                                </div>
                                                                            </div>
                                                                        }

                                                                    </div>
                                                                    <hr/>
                                                                    <div className="row list-view-links">
                                                                        <ul>
                                                                            <li>
                                                                                <a
                                                                                    href={`ucd-case-view/${val?.id}`}>
                                                                                    <i className="fa fa-eye"
                                                                                       aria-hidden="true"></i>&nbsp;&nbsp;

                                                                                    {val?.status === 'LOGGED_IN' ? "View/Mark Approve" : (val?.status === 'REJECTED' || val?.status === 'CANCELLED') ? "Reactive" : "View"}
                                                                                </a>
                                                                            </li>
                                                                            {(val.status !== 'LOGGED_IN' && (val.status === 'APPROVED' || val?.status === 'REQUEST_FOR_PAYMENT_MODIFICATION' || val?.status === 'PAYMENT_DETAILS_ADDED' ||
                                                                                    val.status === 'REQUEST_FOR_PAYMENT_RELEASE' || val.status === 'REQUEST_FOR_PAYMENT_RELEASE_APPROVED' ||
                                                                                    val.status !== 'COMPLETE_PAYMENT_RELEASED')) &&
                                                                                <li>
                                                                                    <a
                                                                                        href={`payment-raise-v2/${val?.id}/${match?.params?.dealer_id}/${match?.params?.id}`}>
                                                                                        <i className="fa fa-tasks"
                                                                                           aria-hidden="true"></i>&nbsp;&nbsp;

                                                                                        {"Payment Raise"}
                                                                                    </a>
                                                                                </li>
                                                                            }
                                                                            {(val?.status === 'LOGGED_IN' || val?.status === 'REQUEST_FOR_CASE_MODIFICATION') &&
                                                                                <li>
                                                                                    <a
                                                                                        href={`ucd-case-edit/${val?.id}/${match?.params?.id}`}>
                                                                                        <i className="fa fa-tasks"
                                                                                           aria-hidden="true"></i>&nbsp;&nbsp;
                                                                                        Edit
                                                                                    </a>
                                                                                </li>
                                                                            }
                                                                        </ul>
                                                                    </div>
                                                                </h6>
                                                                <div className="col-sm-6">
                                                                    <a href={`ucd-add-case/${match?.params?.id}/${match?.params?.dealer_id}`}
                                                                       className="draft-float">
                                                                        <p className="my-float"
                                                                           style={{marginTop: "16px"}}><i
                                                                            className="fa fa-plus"
                                                                            aria-hidden="true"></i></p>
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </>
                                        )
                                        })}

                                    {caseListResponse && caseListResponse?.data !== undefined && caseListResponse?.data !== [] && caseListResponse?.data?.resultSets?.length > 0 &&
                                        <>
                                            <div className="panel-pagination-col panel-table-pagination">
                                                <ReactPaginate
                                                    previousLabel={'<'}
                                                    nextLabel={'>'}
                                                    breakLabel={'...'}
                                                    breakClassName={'break-me'}
                                                    pageCount={(caseListResponse?.data?.total / caseListResponse?.data?.per_page)}
                                                    forcePage={caseListResponse?.data?.current_page - 1}
                                                    pageRangeDisplayed={4}
                                                    onPageChange={onPageChange}
                                                    activeClassName={'active'}
                                                />
                                            </div>
                                        </>
                                    }

                                    {caseListResponse && ((caseListResponse?.data == undefined) || (caseListResponse?.data == []) || (caseListResponse?.data?.resultSets?.length === 0))  &&
                                        <>
                                            <img src={NotFoundData} className="not-found-data" style={{maxWidth: "100%"}} alt={""}/>
                                            <div className="text-center" style={{"width": "100%"}}>
                                                Data Not Found
                                            </div>
                                            <div className="col-sm-6">
                                                <a href={`ucd-add-case/${match?.params?.id}/${match?.params?.dealer_id}`}
                                                   className="draft-float">
                                                    <p className="my-float" style={{marginTop: "16px"}}><i
                                                        className="fa fa-plus"
                                                        aria-hidden="true"></i></p>
                                                </a>
                                            </div>
                                        </>
                                    }
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

                <BottomMenu
                    open={open}
                    setOpen={setOpen}
                    handleSubmitFilter={handleSubmitFilter}
                    filterContent=
                    {{
                        data:[{field:"text", place_holder:"Loan Id"}, {field:"text", place_holder:"Vehicle Number"}]
                    }}
                    handleFilter={handleFilter}
                    setIsRemoveFilter={setIsRemoveFilter}
                />
            </div>
            {/* section ends */}
        </>
    )
}

export default CaseListingV2